module.exports = __webpack_public_path__ + "03_mustache_brown.7b330f9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/03_mustache_brown.png
// module id = wO2C
// module chunks = 0